// import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader
import Vue from "vue";
import Vuetify from "vuetify";
import 'vuetify/dist/vuetify.css';
import es from 'vuetify/es5/locale/es';
import colors from 'vuetify/es5/util/colors';

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'mdiSvg'
  },
  theme: {
    primary: colors.purple,
    secondary: colors.grey.darken1,
    accent: colors.shades.black,
    error: colors.red.accent3
  },
  lang: {
    locales: {
      es
    },
    current: 'es',
  },
});



// WEBPACK FOOTER //
// ./src/plugins/vuetify.js